import React, { useState } from 'react'
import ReactModal from 'react-modal'
import CustomisationConfigModal from './manageBot/CustoisationConfigModal'
import Image from 'react-bootstrap/Image'
import CustomisationBotNameModal from './manageBot/CustoisationConfigModal/CustomisationBotNameModal'
interface IProps {
  config: any
  // intent: any
  // inputJson: any[]
  setConfig: React.Dispatch<React.SetStateAction<any[]>>
  data: any
}

const ConfigPanel: React.FC<IProps> = ({ config, setConfig, data }) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)
  const [isBotNameModalOpen, setIsBotNameModalOpen] = useState<boolean>(false)
  const openModal = () => {
    setIsModalOpen(true)
  }

  const afterOpenModal = () => {
    // subtitle.style.color = '#f00'
  }

  const closeModal = () => {
    setIsModalOpen(false)
  }

  const botName0penModal = () => {
    setIsBotNameModalOpen(true)
  }

  const botNameAfterOpenModal = () => {
    // subtitle.style.color = '#f00'
  }

  const botNameCloseModal = () => {
    setIsBotNameModalOpen(false)
  }

  const customModalStyles = {
    content: {
      top: '45%',
      left: '40%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-15%, -45%)',
      border: '2px solid #dde'
    }
  }

  const headerAvatarUrl = !!config.theme
    ? config.theme.headerAvatarStyle?.content.split('url(')[1].slice(0, -1)
    : ''
  const headerAvatarSrc = headerAvatarUrl ? headerAvatarUrl : ''
  return (
    <div className='card-body px-5 pt-2' id='chat_side_panel_body'>
      <p className='fs-2 text-start fw-bolder mb-3 mb-sm-0'>Configuration</p>

      <ReactModal
        isOpen={isModalOpen}
        onAfterOpen={afterOpenModal}
        onRequestClose={closeModal}
        style={customModalStyles}
        contentLabel='Edit User'
      >
        <CustomisationConfigModal
          // intent={intent}
          closeModal={closeModal}
          config={config}
          // inputJson={inputJson}
          setConfig={setConfig}
          data={data}
        />
      </ReactModal>
      <ReactModal
        isOpen={isBotNameModalOpen}
        onAfterOpen={botNameAfterOpenModal}
        onRequestClose={botNameCloseModal}
        style={customModalStyles}
        contentLabel='Edit User'
      >
        <CustomisationBotNameModal
          // intent={intent}
          closeModal={botNameCloseModal}
          config={config}
          // inputJson={inputJson}
          setConfig={setConfig}
          data={data}
        />
      </ReactModal>

      {!!config && !!config.theme && (
        <>
          <span className='card-text fs-6 col-8'>
            <div className='d-flex justify-content-between'>
              <p className='fw-bolder mb-0 fs-5 text-start mt-3'>WhatsApp Bot Name:</p>
              <span className='mt-3' role='button' onClick={botName0penModal}>
                <i className='bi bi-pen-fill fs-7' />
              </span>
            </div>
            <label
              className='text-start fs-4 fw-bold'
              style={{
                color: '#46bdc3'
              }}
              onClick={botName0penModal}
            >
              {!!config.theme.headerTitle ? config.theme.headerTitle : ''}
            </label>
          </span>

          {!!config.theme.headerAvatarStyle ? (
            <>
              <span className='card fs-6 pt-1 col-8'>
                <label className='fw-bolder mb-3 fs-5 text-start' onClick={openModal}>
                  {/* Header  */}
                  Avatar:
                </label>
                <div className='container'>
                  <Image
                    alt='header'
                    src={headerAvatarSrc}
                    fluid
                    className='headerAvatar mx-n9'
                    style={{ transform: 'scale(0.7)', transformOrigin: '0 0' }}
                    onClick={openModal}
                  />
                </div>
              </span>
            </>
          ) : (
            <>
              <div>
                <span>Your Header-Avatar is not present</span>
              </div>
            </>
          )}
        </>
      )}
    </div>
  )
}

export default ConfigPanel
